import { useGenericContext } from "../../hooks";
import { OidcContext } from "./OidcContext";

export const useOidc = () => useGenericContext(OidcContext);
